<template>
    <div class="grabbingDetail">
        <div class="greyCeng" v-if="isShowCalendar" @click="showCalendar()"></div>
        <calendar v-if="isShowCalendar" :goods_id="goods_id" :date_range="date_range" :ajax_date_range="ajax_date_range"
                  :todayStopSellTime="grabContent.hour_td" @changeShowCalendarStatus="showCalendar()"
                  @userChooseDate="changeDate($event)" @userChoosePrice="changePrices($event)"></calendar>
        <h1>{{grabContent.title}}</h1>
        <p>{{$t('activity_time')}}：{{timestamp(grabContent.start_time)}}</p>
        <div class="grabbing_count_down">
            <div class="product_img">
                <img :src="weburl + grabContent.image" alt="">
            </div>
            <p class="product_detail">
                {{grabContent.description}}
            </p>
            <div class="countdown">
                <p class="ticket_price"><span>￥</span>{{grabContent.price}}<s>￥{{grabContent.shop_price}}</s></p>
                <p v-if="isStart">{{$t('still_time')}}：<i>{{day}}</i>：<i>{{hour}}</i>：<i>{{minutes}}</i>：<i>{{second}}</i></p>
                <p v-else> {{$t('start_time')}}：{{timestamp(grabContent.start_time)}}</p>
                <div class="grabbing_d">
                    <h3>{{$t('grab_num')}} <span>{{$t('all')+grabContent.goods_num+$t('piece')}}</span></h3>
                    <div class="progress">
                        <div class="progressbar">
                            <div class="bar"
                                 :style="{'width': (grabContent.buy_num / grabContent.goods_num) * 100 + '%'}"></div>
                            <div class="label"
                                 :style="{'width': (grabContent.buy_num / grabContent.goods_num) * 100 + '%'}">
                                <span></span>
                                <div>{{(((grabContent.buy_num / grabContent.goods_num) * 100).toFixed(2) + '%')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="select_time" @click="showCalendar()">
                        <label>{{$t('select_time')}}:</label>
                        <input type="text" readonly value="" v-model="date">
                    </div>
                    <div class="select_num"><label>{{$t('select_grab')}}：</label> <span class="del" @click="delNum()">-</span><input
                            type="text" v-model="buyNum" class="buyNumInput"> <span class="add"
                                                                                    @click="addNum()">+</span></div>
                    <span class="buy_ticket" :class="isStart?'buy_btn':'noBuy_btn'" @click="bookingNow()">立即购票</span>
                </div>
            </div>
        </div>
        <div class="activityDetail_content">
            <h4>{{$t('activity_detail')}}</h4>
            <div v-html="replaceHtml(grabContent.goods_content)" class="grabbing_content"></div>
        </div>
    </div>
</template>

<script>
import calendar from "../../components/markets/calendar";
export default {
  name: "grabbingDetail",
  inject: ["showMsg", "replaceHtml"],
  components: {
    calendar
  },
  data() {
    return {
      goods_id: this.$route.query.goods_id,
      date_range: {}, //可以售卖的时间期限
      ajax_date_range: "", //ajax请求回来的售卖时间的数据（未变形）
      isShowCalendar: false, //是否显示日历，默认是不显示日历
      date: "", //用户选择时间
      count: null,
      isStart: true,
      hour: "",
      minutes: "",
      second: "",
      day: "",
      grabContent: "",
      text: "",
      buyNum: 1, //用户选择的购买数量，默认选择购买1
      todayStopSellTimestamps: "" //该商品当天购买的截至时间戳
    };
  },
  created() {
    this.$store.commit("set_current", 3);
    this.$store.commit("set_title", "activity[2]");
    // console.log(this.$route.query.id);
    this.getGrabInfo(this.$route.query.id);
    this.getCanSellDate();
  },
  watch: {
    buyNum: function(n, o) {
      let unitPrice = this.unitPrices;
      unitPrice = parseFloat(unitPrice);
      this.totalPrices = n * unitPrice;
      if (n < 1) {
        this.showMsg("购买数量不能小于1");
        this.buyNum = 1;
      }
      this.totalPrices = (n * unitPrice).toFixed(2);
    }
  },
  methods: {
    getTodayStopSellTimeFuncs: function(hour_td) {
      let todayStopSellDates = this.getNowFormatDate();
      let todayStopSellDateTimestamps =
        new Date(
          (todayStopSellDates + " " + hour_td).replace(/-/g, "/")
        ).getTime() / 1000;
      return todayStopSellDateTimestamps;
    },
    // 立即预定按钮方法
    bookingNow: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/User/checkLogin",
        dataType: "json",
        data: {
          cart: this.selectedNumIdArr,
          lang: window.$lang
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 1) {
            if (res.data.result) {
              // 判断该商品当天是否已经超过售卖时间
              let tody = this.getNowFormatDate();
              let todytp = new Date(tody.replace(/-/g, "/")).getTime() / 1000;
              let userChotp =
                new Date(this.date.replace(/-/g, "/")).getTime() / 1000;
              if (todytp == userChotp) {
                let nowAndNows = new Date().getTime() / 1000;
                if (nowAndNows > this.todayStopSellTimestamps) {
                  this.showMsg("该商品已过当天售卖时间");
                  return false;
                }
              }
              // 利用本地存储技术localStorage将用户选择的本件商品的数据保存到浏览器端，以供在订单页面使用数据
              let goodsOrderInfo = {};
              goodsOrderInfo.goods_id = this.grabContent.goods_id;
              goodsOrderInfo.goods_name = this.grabContent.goods_name;
              goodsOrderInfo.shop_price = this.grabContent.price;
              goodsOrderInfo.original_img = this.grabContent.original_img;
              goodsOrderInfo.goods_num = this.buyNum;
              localStorage.setItem(
                "goodsOrderInfo",
                JSON.stringify(goodsOrderInfo)
              );
              localStorage.setItem("chooseDate", this.date);
              // 跳转到订单页面
              this.$router.push({ path: "/order", query: { to_order_way: 1 } });
            } else {
              this.showMsg("请先登陆");
              // 等1秒跳到登录页面
              setTimeout(() => {
                this.$router.push({ path: "/login" });
              }, 1500);
            }
          } else {
            this.showMsg(this.$t("error_msg"));
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    // 点击“+”号所触发的方法
    addNum: function() {
      this.buyNum += 1;
    },

    // 点击“-”号所触发的方法
    delNum: function() {
      this.buyNum -= 1;
    },
    // ===以下是日历代码===

    // 获取商品开卖的时间，年与月
    getCanSellDate: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Goods/get_goods_is_sell",
        dataType: "json",
        data: {
          goods_id: this.goods_id, //商品id：goods_id
          lang: window.$lang
        }
      })
        .then(res => {
          var year_start = res.data.result.year_start;
          var year_stop = res.data.result.year_stop;
          var month_start = res.data.result.month_start;
          var month_stop = res.data.result.mouth_stop;
          this.ajax_date_range = res.data.result;
          this.create_date_month(
            year_start,
            month_start,
            year_stop,
            month_stop
          );
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    create_date_month: function(
      year_start,
      month_start,
      year_stop,
      month_stop
    ) {
      for (var i = year_start; i <= year_stop; i++) {
        var month_range = [];
        if (year_start == year_stop) {
          for (var j = month_start; j <= month_stop; j++) {
            month_range.push(j);
          }
          this.date_range[i] = month_range;
        } else {
          if (i == year_start) {
            for (var j = month_start; j <= 12; j++) {
              month_range.push(j);
            }
            this.date_range[i] = month_range;
          } else if (i == year_stop) {
            for (var j = 1; j <= month_stop; j++) {
              month_range.push(j);
            }
            this.date_range[i] = month_range;
          } else {
            for (var j = 1; j <= 12; j++) {
              month_range.push(j);
            }
            this.date_range[i] = month_range;
          }
        }
      }
    },
    // 显示日历
    showCalendar: function() {
      this.isShowCalendar = !this.isShowCalendar;
    },
    changeDate: function(date) {
      this.date = date;
    },
    changePrices: function(prices) {},
    initFirstSelectDate: function(time_start, time_stop) {
      let todayT = this.getNowFormatDate();
      todayT = new Date(todayT).getTime() / 1000;
      if (todayT < time_start) {
        this.date = this.timestampToTime(time_start);
      } else if (todayT > time_stop) {
        this.date = this.timestampToTime(time_stop);
      } else {
        this.date = this.timestampToTime(todayT);
      }
    },
    // 时间戳转化为日期的格式
    timestampToTime: function(timestamp) {
      let date = new Date(timestamp * 1000);
      let Y = date.getFullYear() + "-";
      let M = date.getMonth() + 1 + "-";
      let D = date.getDate();
      return Y + M + D;
    },
    getNowFormatDate: function() {
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },

    // ===以上是日历代码===
    getGrabInfo(id) {
      this.$http({
        method: "post",
        url: this.weburl + "home/Activity/flashSaleInfo",
        dataType: "json",
        data: {
          prom_id: id
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.grabContent = res.data.result;
            this.todayStopSellTimestamps = this.getTodayStopSellTimeFuncs(
              res.data.result.hour_td
            );
            this.initFirstSelectDate(
              res.data.result.sell.time_start,
              res.data.result.sell.time_stop
            );
            // this.text = this.grabContent.goods_content.replace(/\/public/g,this.weburl+'/public');
            const timestamp = Date.parse(new Date());
            const now_time = timestamp / 1000;
            if (now_time > this.grabContent.start_time) {
              this.isStart = true;
              clearInterval(this.count);
              this.count = null;
              this.Countdown();
            } else {
              this.isStart = false;
            }
          }
          if (res.data.status == -1 || res.status == -100) {
            this.showMsg(res.data.msg);
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    /**
     * @return {string}
     */
    Timer(m) {
      return m < 10 ? "0" + m : m;
    },
    days(h) {
      if (h < 10) {
        return "00" + h;
      } else if (10 < h < 100) {
        return "0" + h;
      }
    },
    Countdown() {
      const interval = 1000;
      this.count = setInterval(() => {
        const timestamp = Date.parse(new Date());
        const start_time = timestamp / 1000;
        const end_time = this.grabContent.end_time;
        const diff_time = parseInt(end_time - start_time); // 倒计时时间差
        this.day = this.days(Math.floor(diff_time / 3600 / 24));
        this.hour = this.Timer(Math.floor((diff_time / 3600) % 24));
        this.minutes = this.Timer(Math.floor((diff_time / 60) % 60));
        this.second = this.Timer(Math.floor(diff_time % 60));
      }, interval);
    },
    timestamp(start_time) {
      const time = new Date(start_time * 1000);
      const year = time.getFullYear();
      const month = time.getMonth() + 1;
      const date = time.getDate();
      const h = time.getHours();
      const mm = time.getMinutes();
      const s = time.getSeconds();
      return (
        year +
        "-" +
        this.Timer(month) +
        "-" +
        this.Timer(date) +
        "  " +
        this.Timer(h) +
        ":" +
        this.Timer(mm) +
        ":" +
        this.Timer(s)
      );
    }
  },
  destroyed() {
    clearInterval(this.count);
    this.count = null;
  },
  computed: {
    activity_list: function() {
      return this.$store.state.activity.activity_list;
    },
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";

@bg-color: #e73533;
.grabbingDetail {
  width: @width;
  .box-sizing;
  padding: 30px 20px 10px;
  & > h1 {
    font-size: @font + 0.4;
    line-height: @font * 2;
    margin-bottom: 10px;
  }
  & > p {
    margin-bottom: 10px;
    font-size: @font;
    padding-bottom: 10px;
    .border-bottom;
  }
  .grabbing_count_down {
    .product_img {
      width: @width;
      height: 200px;
      margin-bottom: 10px;
      img {
        .img;
      }
    }
    .product_detail {
      color: @word;
      font-size: 0.9rem;
      line-height: 20px;
      margin-bottom: 20px;
    }
    .countdown {
      .ticket_price {
        font-size: @font * 4;
        span {
          font-size: @font + 0.5;
        }
        s {
          margin: 10px 0;
          display: block;
          font-size: 0.9rem;
          color: @word;
        }
      }
      p {
        text-align: center;
        font-size: 0.9rem;
        color: @bg-color;
        i {
          padding: 2px;
          background: @bg-color;
          color: @font-primary;
        }
      }
    }
  }
}

.activityDetail_content {
  width: @width;
  & > h4 {
    .border-bottom;
    height: 25px;
  }
}

/*加减按钮*/
.select_num {
  margin: 10px 0;
  padding-left: 6%;
  height: 32px;
  line-height: 32px;
  font-size: 0.9rem;
  label {
    position: relative;
    &:before {
      position: absolute;
      top: -6px;
      left: -11px;
      color: @bg-color;
      content: "*";
      font-size: @font;
    }
  }

  span {
    width: 32px;
    height: 32px;
    float: right;
    text-align: center;
    color: @font-primary;
    background: @brick_red;
    line-height: 32px;
    font-size: @font + 0.4;
    .border-radius(4px);
    &.add {
      margin-right: 5px;
    }
    &.del {
      margin-left: 5px;
    }
  }
  input {
    float: right;
    width: 30px;
    border: 1px solid @brick_red;
    .border-radius(4px);
    height: 30px;
  }
}

.buyNumInput {
  text-align: center;
}

.progress {
  height: 20px;
  position: relative;
}

.progressbar {
  height: 20px;
  background: @bg;
  margin: 8px 0;
  overflow: hidden;
  .border-radius(4px);
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  width: @width;
}

.bar {
  .border-radius(4px);
  height: 20px;
  background: url("../../assets/images/activity/speed.png");
}

.label {
  position: absolute;
  width: 34px;
  height: 17px;
  top: 30px;
  left: 0;
  font-size: 0.9rem;
  span {
    position: absolute;
    display: block;
    width: 28px;
    height: 9px;
    top: -12px;
    left: 0;
    background: transparent;
    overflow: hidden;
    &:before {
      content: "";
      width: 6px;
      height: 6px;
      top: 6px;
      left: 5px;
      background: @bg-color;
      -moz-transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
}

.grabbing_d h3 {
  width: 100%;
  font-size: 0.9rem;
  margin-top: 15px;
  font-weight: normal;
  span {
    float: right;
  }
}

.select_time {
  text-align: center;
  margin: 35px 0 0;
  font-size: 0.9rem;
  label {
    position: relative;
    &:before {
      top: 1px;
      left: -11px;
      color: @bg-color;
      content: "*";
      font-size: @font;
    }
  }
  input {
    padding: 0 8px;
  }
}

.buy_ticket {
  display: block;
  .width;
  .btn;
}

.buy_btn {
  background-color: @bg-color;
}

.noBuy_btn {
  background-color: #32b16c;
}

.greyCeng {
  height: 100vh;
  width: 100vw;
  position: fixed;
  background-color: gray;
  opacity: 0.5;
  z-index: 101;
  top: 0;
  left: 0;
}
</style>
<style>
.activityDetail_content >>> img {
  width: 100%;
}

.activityDetail_content video {
  width: 100% !important;
  height: 100%;
}

.grabbing_content {
  padding: 10px 0;
  line-height: 24px;
}
</style>
